/* eslint-disable @nx/enforce-module-boundaries */
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ArrowDown, CloseIcon } from '@mybridge/icons';
import { Box, Button, Checkbox, CheckboxGroup, HStack, Stack, Text } from '@mybridge/ui';
import { forwardRef, useMemo, useState, useEffect, useContext } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { CustomRadioButton } from 'v4/components/custom-radio-checkbx';
import { FilterPopover } from 'v4/components/filter-popover';
import { useRadioGroup } from '@chakra-ui/react';
import { SearchContext } from '../../../snippets/search/context';
import styles from '../../filter-popover/filter-popover.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useSelector } from 'react-redux';
import _ from 'lodash';

export const SearchFilterCompanySize = forwardRef(
  (
    {
      name = 'company_size',
      title = 'Company Size',
      titleKey = 'createPage.companySize',
      onChange,
      value,
      defaultValue,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslator();
    const currentLanguage = useSelector((state) => state.translation.language) || 'en';
    const [selectedValue, setSelectedValue] = useState();
    const [popperOpen, setPopperOpen] = useState(false);
    const { resetFilters, setResetFilters } = useContext(SearchContext);
    const values = useMemo(
      () => [
        {
          title: t('searchPage.selfEmployed') || 'Self-Employed',
          value: '1',
        },
        {
          title: t('searchPage.size1To10') || '1-10 Employees',
          value: '2',
        },
        {
          title: t('searchPage.size11To50') || '11-50 Employees',
          value: '3',
        },
        {
          title: t('searchPage.size51To200') || '51-200 Employees',
          value: '4',
        },
        {
          title: t('searchPage.size201To500') || '201-500 Employees',
          value: '5',
        },

        {
          title: t('searchPage.size501To1000') || '501-1,000 Employees',
          value: '6',
        },
        {
          title: t('searchPage.size1001To5000') || '1,001-5,000 Employees',
          value: '7',
        },
        {
          title: t('searchPage.size5001To10000') || '5,001-10,000 Employees',
          value: '8',
        },
        {
          title: t('searchPage.size10000Plus') || '10,000+ Employees',
          value: '9',
        },
      ],
      [t, currentLanguage]
    );

    const { handleSubmit, control } = useForm();

    useEffect(() => {
      selectedValue ? setResetFilters(true) : setResetFilters(false)
    }, [selectedValue]);

    useEffect(() => {
      if(!resetFilters){
        setSelectedValue();
      }
    }, [resetFilters]);

    const onSubmit = (form) => {
      const data_ = _.find(values, function(o){return o.value == form});
      onChange?.({[name]:form});
      setSelectedValue(data_?.title);
      setPopperOpen(false);
    };

    const { getRadioProps, getRootProps } = useRadioGroup({
      onChange: onSubmit,
    })

    return (
      <>
          <FilterPopover
            trigger={
              <Button
                variant="transparent"
                fontSize="14px"
                color="brandGray.750"
                justifyContent="space-between"
                w="100%"
                px={1}
              >
                <HStack w="100%" justifyContent="space-between" spacing={1} overflow="hidden">
                  <Text noOfLines={1} textAlign="left" flex={1} title={selectedValue && resetFilters ? selectedValue : (t(titleKey) || title)}>
                    {selectedValue && resetFilters ? selectedValue : (t(titleKey) || title)}
                  </Text>
                  <Box flexShrink={0}>
                    {selectedValue && resetFilters ? (
                      <CloseIcon width="15" height="15" color="#3D5A80" cursor="pointer" onClick={(e) => { e.stopPropagation(); onSubmit(null); }} />
                    ) : (
                      <ArrowDown />
                    )}
                  </Box>
                </HStack>
              </Button>
            }
            onPopClose={(e) => setPopperOpen(e)}
          >
            <Controller
              render={({ field }) => (
                <CheckboxGroup {...field}>
                  <Stack maxH="130px"
                    height="100%"
                    overflowY="auto" className={styles.filterList}>
                    {values?.map?.((v, vIndex) => (
                      // <Checkbox key={vIndex} value={v?.value}>
                      //   {v?.title}
                      // </Checkbox>
                      <CustomRadioButton key={vIndex} justifyContent="flex-start" {...getRadioProps({ value: v?.value })}>{v?.title}</CustomRadioButton>
                    ))}
                  </Stack>
                </CheckboxGroup>
              )}
              control={control}
              name={name}
            />
          </FilterPopover>
        {/* </form> */}
      </>
    );
  }
);
